import { clsx } from 'clsx'

import { Link, Text } from '@buffer-mono/popcorn'

import { getDisplayServiceName } from '../../util/channelHelpers'
import { RETENTION_NOTICE_TEXT } from '../../util/retention'

import styles from './RetentionNotice.module.css'

type RetentionNoticeProps = {
  /** With `service`, appends a link to the post on the network. */
  externalLink?: string | null
  service?: string
  className?: string
}

/** Tells the reader that only the retention window is shown. */
export const RetentionNotice = ({
  externalLink,
  service,
  className,
}: RetentionNoticeProps): JSX.Element => {
  return (
    <div
      className={clsx(styles.notice, className)}
      data-testid="retention-notice"
    >
      <Text size="sm" color="subtle">
        {RETENTION_NOTICE_TEXT}
        {externalLink && service ? (
          <>
            {' '}
            <Link href={externalLink} external color="inherit">
              View full thread on {getDisplayServiceName(service)}
            </Link>
          </>
        ) : null}
      </Text>
    </div>
  )
}
